(() => {
  const initialize = (root) => {
    if (!root || root.dataset.apLegalReady === 'true') return;
    root.dataset.apLegalReady = 'true';

    const navigation = root.querySelector('.aura-toc');
    const navigationLabel = root.dataset.tocLabel || '';
    if (navigation && navigationLabel) {
      navigation.setAttribute('aria-label', navigationLabel);
      const label = document.createElement('p');
      label.className = 'ap-legal-page__toc-label';
      label.textContent = navigationLabel;
      navigation.prepend(label);
    }

    root.querySelectorAll('.aura-card summary').forEach((summary) => {
      if (summary.querySelector(':scope > h2')) return;
      const heading = document.createElement('h2');
      while (summary.firstChild) heading.append(summary.firstChild);
      summary.append(heading);
    });

    const openTarget = (hash, focus = false) => {
      if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return;

      let targetId;
      try {
        targetId = decodeURIComponent(hash.slice(1));
      } catch (error) {
        return;
      }

      const target = document.getElementById(targetId);
      if (target && !root.contains(target)) return;
      const details = target?.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;
      details.open = true;
      if (focus) requestAnimationFrame(() => summary.focus({ preventScroll: true }));
    };

    navigation?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      openTarget(link.getAttribute('href'), true);
    });

    openTarget(window.location.hash);
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-ap-legal-page]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
